import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import { styled } from '@mui/system';
import CafeMedia from '../CafeMedia';
import CafeName from '../CafeName';
import CafeAbout from '../CafeAbout';
import CafeIsOpen from '../CafeIsOpen';
import CafeActions from '../CafeActions';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';

const CafeProfileCardContainer = styled(Card)(({ theme }) => ({
  maxWidth: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  marginTop: '70px',
  gap: '50px',
  border: 'none',
  boxShadow: 'none',
  backgroundColor: 'transparent',
  [theme.breakpoints.down('850')]: {
    flexDirection: 'column',
    marginTop: '40px',
  },
}));

const CardContentBox = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  width: '30rem',
  flexGrow: 1,
  flexDirection: 'column',
  alignItems: 'flex-start',
  marginTop: '-15px',
  gap: '10px',
  [theme.breakpoints.down('850')]: {
    marginTop: '-55px',
    padding: '0px 30px 0 20px',
    alignItems: 'center',
  },
}));

const CafeProfileCard = (props) => {
  const currentUserId = useSelector(selectUser);

  return (
    <CafeProfileCardContainer>
      <CafeMedia cafePics={props.cafe.attachments} />
      <CardContentBox>
        <CafeName cafeData={props.cafe} currentUser={currentUserId} />
        <CafeActions cafeData={props.cafe} currentUser={currentUserId} />
        <CafeAbout cafeData={props.cafe} />
        <CafeIsOpen cafeData={props.cafe} />
      </CardContentBox>
    </CafeProfileCardContainer>
  );
};
export default CafeProfileCard;
